import FinderViewBase from '../FinderViewBase/FinderViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EmploymentPropositionHome.html?raw';
import on from 'dojo/on';
import "../FileFinder/FileFinderTypes";
import "../../moreCore/UI/Button/Button";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';

//import PropositionForm = require("../EmploymentProposition/EmploymentPropositionForm");
import EmploymentPropositionForm from './EmploymentPropositionForm';
import { EmploymentPropositionTypes } from "./OE_Types";

//import "../EmploymentProposition/EmploymentPropositionTypes";
class EmploymentPropositionHome extends compose(FinderViewBase) {
    templateString: any = template;

    resultActionbar: HTMLElement;
    buttonClickTimeout: number = null;

    private _propForm: MdsLax<InstanceType<typeof EmploymentPropositionForm>> = null;
    private _propFormDlg: MdsLax<InstanceType<typeof GenericDialog>> = null;
    private _selectedEngagementID: string = null;

    // damit man das name und containerNode im Bedarfsfall nur an einer Stelle ändern muss
    tableParams: tableParams = { widgetName: "table", sContainerNodeName: "resultContainer" };

    // das alles bekommen wir dann von der API evtl oder whatever -- parameter die sich nicht ändern
    entityListAttributeName = "entitylist";
    loadFilterDatatUrl = "EmploymentProposition/GetProjectList";
    loadFinderConfigUrl = "EmploymentProposition/GetFilterpanelOptions";
    btnContinueLabelText = (this as any).translations["EmploymentProposition_BtnSubmitNext"];
    btnSubmitLabelText = (this as any).translations["EmploymentProposition_BtnSubmit"];

    protected _tableLayouts: Array<StaticTable.Layout> = [{
        "name": "default",
        "label": "Default",
        rows: [{
            "attributes": [
                "ev_project_name",
                "ref_artistic_period.description",
                "",
                "",
                ""
            ],
            "colspans": [
                1,
                1,
                1,
                1,
                1
            ],
            "headings": [
                (this as any).translations["EmploymentProposition_TableColHead_ProjectName"],
                (this as any).translations["EmploymentProposition_TableColHead_ArtisticPeriod"],
                (this as any).translations["EmploymentProposition_TableColHead_Proposition"],
                (this as any).translations["EmploymentProposition_TableColHead_ConfirmedProposition"],
                (this as any).translations["EmploymentProposition_TableColHead_Actions"]
            ],
            "colNamesInternal": [
                "project",
                "artisticPeriod",
                "proposition",
                "confirmedProp",
                "actions"
            ]
        }]
        
    }]

    table_Formatter(cell: StaticTable.StaticTableCell<EmploymentPropositionTypes.EmploymentPropositionEntity>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let index = cell.tableRow.lineIndex;
        let value = cell.value;
        switch (colName) {
            
            default:
                return false;
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // overrides -----------------------------------------------start
    _onClick_Submit(evt: Event) {
        if (this._isRequestActive === true || (this.getDirty() != true && this._completeList.length >= this.lastResponse.totalResultCount)) {
            return;
        }
        this.getFilterlist();
    }

    drawActionButtons(node: HTMLElement, entity: EmploymentPropositionTypes.EmploymentPropositionEntity) {
        let button = this.UiModder.domConstruct.create("button",
            {
                "className": "mds-button-base round mds-hover-bright secondaryBG",
                "innerHTML": "zur Anmeldung..."
            },
            node
        );

        on(button, "click", lang.hitch(this, this.showPropositionForm, entity, node.parentElement.parentElement));
    }

    showPropositionForm(entity: EmploymentPropositionTypes.EmploymentPropositionEntity, tablerow: HTMLTableRowElement) {

        if (this._propFormDlg != null) {
            this._propFormDlg.destroy();
            this._propFormDlg = null;
        }

        let dlg = new GenericDialog();
        this._propFormDlg = dlg;

        dlg._setHeaderAttr(this.translations["EmploymentProposition_EmploymentProposition_PropositionFor"] + " " + entity.ID);

        dlg._setOkBtnAttr(true);
        dlg._setCancelBtnAttr(true);
        dlg.setCloseOnEnter(false);
        dlg.setCloseOnEscape(false);
        dlg._setCloseBtnAttr(false);

        dlg.destroyOnClose = false;

        let propForm = new EmploymentPropositionForm();
        propForm.set("entity", entity);
        propForm.set("engagementID", this._selectedEngagementID);
        propForm.startup();

        this._propForm = propForm;

        dlg.addNodeToContent(propForm.domNode);


        dlg.show();
    }

   
    

    // was wollen wir mit den FilterDaten anstellen
    processFilterListResponse_callback(): void {
        if (this.tableParams) {
            let engagementID = "";
            let option = this.getFilterOptionByName("myEngagements");

            if (option) {
                engagementID = <string>option.getValue();
            }
            this._selectedEngagementID = engagementID;

            // z.B. gleich eine Tabelle kreieren
            this.createTable(this.tableParams.widgetName,
                this[this.tableParams.sContainerNodeName],
                "default",
                this._completeList,
                lang.hitch(this, this.table_Formatter));
        } 
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EmploymentPropositionHome);